import React, { useState, useEffect, useRef } from 'react';
import './HomeSlider.css';

const images = [
  { src: '/images/momentos-unicos.jpg', alt: 'Foto 1', title: 'Momentos Únicos', subtitle: 'Capturando la esencia de cada instante' },
  { src: '/images/naturaleza-viva.jpg', alt: 'Foto 2', title: 'Naturaleza Viva', subtitle: 'La belleza en cada detalle' },
  { src: '/images/emociones-puras.jpg', alt: 'Foto 3', title: 'Emociones Puras', subtitle: 'Fotografía que habla al corazón' },
  { src: '/images/simple-ideas.jpg', alt: 'Foto 4', title: 'Simple Ideas', subtitle: 'Donde cada imagen cuenta una historia' },
];

const HomeSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [isAnimating, setIsAnimating] = useState(true);
  const slideRef = useRef();

  const extendedImages = [ images[images.length - 1], ...images, images[0] ];
  const totalSlides = images.length;

  const nextSlide = () => { if (currentIndex < totalSlides + 1) setCurrentIndex(currentIndex + 1); };
  const prevSlide = () => { if (currentIndex > 0) setCurrentIndex(currentIndex - 1); };

  useEffect(() => {
    const interval = setInterval(nextSlide, 8000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleTransitionEnd = () => {
    if (currentIndex === 0) { setIsAnimating(false); setCurrentIndex(totalSlides); }
    else if (currentIndex === totalSlides + 1) { setIsAnimating(false); setCurrentIndex(1); }
  };
  useEffect(() => {
    if (!isAnimating) {
      const t = setTimeout(() => setIsAnimating(true), 20);
      return () => clearTimeout(t);
    }
  }, [isAnimating]);

  return (
    <div className="slider-wrapper">
      <div
        ref={slideRef}
        className={`slider-track ${isAnimating ? 'animate' : ''}`}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        onTransitionEnd={handleTransitionEnd}
      >
        {extendedImages.map((img, index) => {
          const isReal = index !== 0 && index !== extendedImages.length - 1;
          const realIdx = isReal ? index - 1 : null;
          return (
            <div className="slide-item" key={index}>
              <img src={img.src} alt={img.alt} draggable="false" onContextMenu={(e)=>e.preventDefault()} />
              <span className="slide-scrim" aria-hidden="true" />
              {isReal && (
                <div className="centered-copy">
                  <h2 className="hero-title">{images[realIdx].title}</h2>
                  <p className="hero-subtitle">{images[realIdx].subtitle}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <button className="nav-button left" onClick={prevSlide} aria-label="Anterior">❮</button>
      <button className="nav-button right" onClick={nextSlide} aria-label="Siguiente">❯</button>
    </div>
  );
};

export default HomeSlider;
